export const INSURANCE_SUMMARY_REQUEST = 'INSURANCE_SUMMARY_REQUEST'
export const INSURANCE_SUMMARY_SUCCESS = 'INSURANCE_SUMMARY_SUCCESS'
export const INSURANCE_SUMMARY_FAIL = 'INSURANCE_SUMMARY_FAIL'

// ** Insurance Detail
export const DETAIL_INSURANCE_REQUEST = 'DETAIL_INSURANCE_REQUEST'
export const DETAIL_INSURANCE_SUCCESS = 'DETAIL_INSURANCE_SUCCESS'
export const DETAIL_INSURANCE_FAIL = 'DETAIL_INSURANCE_FAIL'

// ** Insurance PIC & Invoice Address
export const LIST_INSURANCE_INVOICE_ADDRESS_REQUEST = 'LIST_INSURANCE_INVOICE_ADDRESS_REQUEST'
export const LIST_INSURANCE_INVOICE_ADDRESS_SUCCESS = 'LIST_INSURANCE_INVOICE_ADDRESS_SUCCESS'
export const LIST_INSURANCE_INVOICE_ADDRESS_FAIL = 'LIST_INSURANCE_INVOICE_ADDRESS_FAIL'

export const LIST_INSURANCE_INVOICE_ADDRESS_SUMMARY_REQUEST = 'LIST_INSURANCE_INVOICE_ADDRESS_SUMMARY_REQUEST'
export const LIST_INSURANCE_INVOICE_ADDRESS_SUMMARY_SUCCESS = 'LIST_INSURANCE_INVOICE_ADDRESS_SUMMARY_SUCCESS'
export const LIST_INSURANCE_INVOICE_ADDRESS_SUMMARY_FAIL = 'LIST_INSURANCE_INVOICE_ADDRESS_SUMMARY_FAIL'

export const CREATE_INSURANCE_INVOICE_ADDRESS_REQUEST = 'CREATE_INSURANCE_INVOICE_ADDRESS_REQUEST'
export const CREATE_INSURANCE_INVOICE_ADDRESS_SUCCESS = 'CREATE_INSURANCE_INVOICE_ADDRESS_SUCCESS'
export const CREATE_INSURANCE_INVOICE_ADDRESS_FAIL = 'CREATE_INSURANCE_INVOICE_ADDRESS_FAIL'

export const DETAIL_INSURANCE_INVOICE_ADDRESS_REQUEST = 'DETAIL_INSURANCE_INVOICE_ADDRESS_REQUEST'
export const DETAIL_INSURANCE_INVOICE_ADDRESS_SUCCESS = 'DETAIL_INSURANCE_INVOICE_ADDRESS_SUCCESS'
export const DETAIL_INSURANCE_INVOICE_ADDRESS_FAIL = 'DETAIL_INSURANCE_INVOICE_ADDRESS_FAIL'

export const RESET_DETAIL_INSURANCE_INVOICE_ADDRESS = 'RESET_DETAIL_INSURANCE_INVOICE_ADDRESS'

export const UPDATE_INSURANCE_INVOICE_ADDRESS_REQUEST = 'UPDATE_INSURANCE_INVOICE_ADDRESS_REQUEST'
export const UPDATE_INSURANCE_INVOICE_ADDRESS_SUCCESS = 'UPDATE_INSURANCE_INVOICE_ADDRESS_SUCCESS'
export const UPDATE_INSURANCE_INVOICE_ADDRESS_FAIL = 'UPDATE_INSURANCE_INVOICE_ADDRESS_FAIL'

export const DELETE_INSURANCE_INVOICE_ADDRESS_REQUEST = 'DELETE_INSURANCE_INVOICE_ADDRESS_REQUEST'
export const DELETE_INSURANCE_INVOICE_ADDRESS_SUCCESS = 'DELETE_INSURANCE_INVOICE_ADDRESS_SUCCESS'
export const DELETE_INSURANCE_INVOICE_ADDRESS_FAIL = 'DELETE_INSURANCE_INVOICE_ADDRESS_FAIL'